import { useEffect } from "react"
import AddInventorBox from "./AddInventorBox"

type InventorSectionProps = {
  hideHeader?: boolean
  onChange?: (list: any[]) => void
  initialData?: any[] | null
  disabled?: boolean
}

export default function InventorSection({
  hideHeader = false,
  onChange,
  initialData,
  disabled = false
}: InventorSectionProps) {
  useEffect(() => {
    const list = initialData || []
    const complete = list.length > 0

    window.dispatchEvent(
      new CustomEvent("sectionComplete", {
        detail: { section: "inventors", complete }
      })
    )
  }, [initialData])

  return (
    <section>
      {!hideHeader && (
        <>
          <h2 className="text-xl font-semibold text-gray-800">Inventors</h2>
          <p className="text-sm text-gray-600 mb-4">
            Name every inventor of this invention, or indicate that they have
            waived the right to be mentioned.
          </p>
        </>
      )}

      <AddInventorBox
        onChange={onChange}
        initialData={initialData || undefined}
        disabled={disabled}
      />

      {!hideHeader && <hr className="border-t border-gray-200 mt-8" />}
    </section>
  )
}
